var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowerRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.999 24.5C84.1715 24.5 83.3565 24.545 82.549 24.6225C76.8515 16.975 67.769 12 57.499 12C43.2165 12 31.199 21.5925 27.469 34.6775C17.6215 35.9225 9.99902 44.3125 9.99902 54.5C9.99902 65.545 18.954 74.5 29.999 74.5C34.544 74.5 80.2665 74.5 84.999 74.5C98.8065 74.5 109.999 63.3075 109.999 49.5C109.999 35.6925 98.8065 24.5 84.999 24.5Z",
    fill: "url(#paint0_linear_184103_183564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5334 95.533C76.5809 97.4855 73.4159 97.4855 71.4634 95.533C69.5109 93.5805 69.5109 90.4155 71.4634 88.463C73.4159 86.5105 82.4984 84.498 82.4984 84.498C82.4984 84.498 80.4859 93.5805 78.5334 95.533Z",
    fill: "url(#paint1_linear_184103_183564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0353 90.535C34.0828 92.4875 30.9179 92.4875 28.9654 90.535C27.0129 88.5825 27.0129 85.4175 28.9654 83.465C30.9179 81.5125 40.0004 79.5 40.0004 79.5C40.0004 79.5 37.9878 88.5825 36.0353 90.535Z",
    fill: "url(#paint2_linear_184103_183564)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5344 105.535C51.5819 107.488 48.4169 107.488 46.4644 105.535C44.5119 103.583 44.5119 100.417 46.4644 98.465C48.4169 96.5125 57.4994 94.5 57.4994 94.5C57.4994 94.5 55.4869 103.583 53.5344 105.535Z",
    fill: "url(#paint3_linear_184103_183564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184103_183564",
    x1: 53.2815,
    y1: 12.1975,
    x2: 64.044,
    y2: 75.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482325,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184103_183564",
    x1: 82.998,
    y1: 84.498,
    x2: 76.2487,
    y2: 96.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184103_183564",
    x1: 40.5,
    y1: 79.5,
    x2: 33.7507,
    y2: 91.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_184103_183564",
    x1: 57.999,
    y1: 94.5,
    x2: 51.2497,
    y2: 106.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerRain);
export default __webpack_public_path__ + "static/media/shower-rain.904adf0987be526f882ca788dbaf623a.svg";
export { ForwardRef as ReactComponent };